import { IonContent } from '@ionic/react';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { webCampaign } from '@/modules/webCampaign';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { AI_DATA } from '@/pages/Onboarding/constants';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OnboardingParamsTool } from '@/pages/Onboarding/utils/paramsTool';
import { canLogEvents } from '@/utils/canLogEvents';
import { preloadImage } from '@/utils/preloadImage';

import { OnboardingAppUsersStyles } from './AppUsers.styles';

export const ScreenAppUsers: React.FC = () => {
  const { wizard } = useOnboarding();

  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Pheon Users',
      });
    }

    // Preload images
    const aiCharacteristicData = AI_DATA[webCampaign.aiType].characteristics;
    aiCharacteristicData.forEach((category) => preloadImage(category.imageSrc));
  }, []);

  const handleNextStep = () => {
    wizard.nextStep();
    OnboardingParamsTool.setParam('step', 'interests');
  };

  return (
    <OnboardingAppUsersStyles background="none">
      <OnboardingNavigation dotColor="white" />

      <IonContent>
        <div className="image-container">
          <img
            src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/AppUsers/planet_static.png"
            alt="planet"
          />
        </div>
        <div className="description">
          <OnboardingTitle color="white">
            Welcome to your AI universe!
          </OnboardingTitle>
          <OnboardingSubtitle color="white">
            You’ve joined 1,556,867 of Dialogue users worldwide
          </OnboardingSubtitle>
        </div>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </OnboardingAppUsersStyles>
  );
};
